import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import iconStep1 from '../assets/images/icon-phone-paper.png';
import iconStep2 from '../assets/images/icon-job-search.png';
import iconStep3 from '../assets/images/icon-man-time.png';


export class HowItWorksIcons extends React.Component {
  render() {
    const {classes} = this.props;

    return (
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className={`${classes.sectionHeader} text-center`}>How it works</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 text-center">
            <img className={classes.howItWorksImage} src={iconStep1}/>
            <h4 className={classes.howItWorksItem}>1. Post Shift</h4>
            <p className="text-demphasis">Enter the details of your shift and set what you're willing to pay.</p>
          </div>
          <div className="col-md-4 text-center">
            <img className={classes.howItWorksImage} src={iconStep2}/>
            <h4 className={classes.howItWorksItem}>2. Get a Pro</h4>
            <p className="text-demphasis">We send your shift via SMS and find a qualified Pro.</p>
          </div>
          <div className="col-md-4 text-center">
            <img className={classes.howItWorksImage} src={iconStep3}/>
            <h4 className={classes.howItWorksItem}>3. Fill Your Shift</h4>
            <p className="text-demphasis">After your shift, we pay the Pro on your behalf.</p>
          </div>
        </div>
      </div>
    )
  }
}

const styles = (theme) => ({
  sectionHeader: {
    paddingBottom: 30,
  },
  howItWorksItem: {
    fontSize: '20px',
    lineHeight: '30px',
    margin: '10px 0 5px',
    fontWeight: 'bold',
  },
  howItWorksImage: {
    width: '100px',
  },
});

export default (withStyles(styles)(HowItWorksIcons));



// WEBPACK FOOTER //
// ./src/parts/HowItWorksIcons.js